/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Banner action size enumeration.
 */
export type BannerSize = typeof BannerSize[keyof typeof BannerSize];


export const BannerSize = {
  large: 'large',
  small: 'small',
} as const;
